import styled from 'styled-components';

export const FooterWarningConsentText = styled.p`
  font-size: ${({ theme }) => theme.fontSize.m};
  color: ${({ theme }) => theme.colors.dimGray};
  text-align: center;
`;
export const FooterWarningConsentLink = styled.a`
  font-size: ${({ theme }) => theme.fontSize.m};
  color: ${({ theme }) => theme.colors.azure};
  text-align: center;
`;

export const FooterWarningConsentLinkSeparator = styled.span`
  margin: 0 6px;
`;

export const FooterWarningConsentLinksContainer = styled.div`
  text-align: center;
  margin-bottom: 20px;
`;
